<template>
  <div class="page-article-edit">
    <app-page-box title="发布文章">
      <el-alert type="error" :title="`优化师根据您所提供的主营业务/品牌/竞品及网民在各大搜索引擎的检索习惯共找出 ${keywordPackages.totalKeywordCount} 个符合您业务的关键词，接下来将进行智能推广。`"></el-alert>
      <el-form class="page-article-edit__form" :model="form" :rules="rules" ref="form" label-width="80px" status-icon>
        <el-form-item label="标题" prop="title" size="small">
          <div style="display: inline-block; width: 420px">
            <el-input type="text" v-model="form.title" placeholder="请输入文章标题5-30字"></el-input>
          </div>
          <!-- <span class="page-article-edit__keyword-tip">提示：标题必须包含关键词</span> -->
        </el-form-item>
        <el-form-item label="摘要" prop="summary" size="small" style="width: 500px">
          <el-input type="textarea" v-model="form.summary" placeholder="请输入文章摘要10-125字"></el-input>
        </el-form-item>
        <el-form-item label="关键词" prop="keywords" size="small">
          <div class="page-article-edit__keyword-selected" v-if="form.keywords.length">{{ form.keywords.map(k => k.keyword).join(', ') }}</div>
          <app-keyword-picker :value="form.keywords" @ok="handleKeywordOk">
            <el-button type="info" size="small" plain>选择关键词</el-button>
          </app-keyword-picker>
          <span class="page-article-edit__keyword-tip">为更好的展示排名，每篇文章只能选择1个关键词</span>
        </el-form-item>
        <el-form-item label="正文" prop="content" size="small">
          <sme-editor v-model="form.content" @input="handleEditorInput" placeholder="请编辑文章正文"></sme-editor>
        </el-form-item>
        <el-form-item class="page-article-edit__submit">
          <el-button size="small" @click="handleCancel">取消</el-button>
          <el-button type="danger" size="small" @click="handleSaveToDraft">保存为草稿</el-button>
          <el-button type="primary" size="small" @click="handlePublish">确认发布</el-button>
        </el-form-item>
      </el-form>
    </app-page-box>
  </div>
</template>

<script>
import AppPageBox from '@/components/AppPageBox'
import AppKeywordPicker from '@/components/AppKeywordPicker'
import { findImageIds, includeKeyword } from '@/utils'

export default {
  name: 'PageArticleEdit',
  components: {
    AppPageBox,
    AppKeywordPicker
  },

  data () {
    return {
      rules: {
        title: [
          { required: true, message: '请输入文章标题', trigger: 'change' },
          { min: 5, max: 30, message: '文章标题：5-30字', trigger: 'change' }
        ],
        summary: [
          { required: true, message: '请输入文章摘要', trigger: 'change' },
          { min: 10, max: 125, message: '文章摘要：10-125字', trigger: 'change' }
        ],
        // keywords: [
        //   { type: 'array', required: true, message: '请选择关键词', trigger: 'manual' }
        // ],
        content: [
          { required: true, message: '请编辑文章正文', trigger: 'input' }
        ]
      }
    }
  },

  computed: {
    user () {
      return this.$store.state.account.user
    },
    form () {
      return this.$store.state.article.currentArticle
    },
    keywordPackages () {
      return this.$store.state.keyword.keywordPackages
    }
  },

  created () {
    this.getCurrentArticle()
    this.getKeywordPackages()
  },

  destroyed () {
    this.$store.commit('SET_CURRENT_ARTICLE', { /* emptyArticle */ })
  },

  methods: {
    getCurrentArticle () {
      const articleId = this.$route.query.id
      const user = this.user

      if (!articleId) return

      this.$store.dispatch('getArticleById', {
        params: {
          userId: user.id,
          articleId: articleId
        }
      })
    },

    getKeywordPackages () {
      this.$store.dispatch('getKeywordPackages', {
        params: { userId: this.user.id }
      })
    },

    adapteRequestBody (data, status) {
      return {
        article: {
          title: data.title,
          summary: data.summary,
          keywords: data.keywords,
          content: data.content,
          imageList: findImageIds(data.content),
          articleType: 1, // 1) 原创 2) 伪原创 3) 转载
          status: status, // -1) 无效文章 0) 草稿 1) 待审核 2) 审核通过 3) 审核驳回 4) 发布中 5) 发布成功 6) 发布失败
          publishSite: { id: 1 }
        }
      }
    },

    createArticle (data, status, cb) {
      this.$store.dispatch('createArticle', {
        params: { userId: this.user.id },
        body: this.adapteRequestBody(data, status)
      }).then(response => {
        this.$message({
          type: 'success',
          message: '创建文章成功!'
        })
        cb && cb()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '创建文章失败!'
        })
      })
    },

    updateArticle (data, status, cb) {
      const articleId = this.$route.query.id
      const user = this.user

      this.$store.dispatch('updateArticle', {
        params: {
          userId: user.id,
          articleId: articleId
        },
        body: this.adapteRequestBody(data, status)
      }).then(response => {
        this.$message({
          type: 'success',
          message: '更新文章成功!'
        })
        cb && cb()
      }).catch(() => {
        this.$message({
          type: 'error',
          message: '更新文章失败!'
        })
      })
    },

    saveArticle (data, status, cb) {
      const articleId = this.$route.query.id

      if (articleId) {
        this.updateArticle(data, status, cb)
      } else {
        this.createArticle(data, status, cb)
      }
    },

    submit (cb) {
      this.$refs.form.validate(valid => {
        if (valid) cb && cb(this.form)
      })
      // this.checkTitle((error) => {
      //   if (!error) {
      //     this.$refs.form.validate(valid => {
      //       if (valid) cb && cb(this.form)
      //     })
      //   } else {
      //     this.$alert('标题必须包含关键词', '提示', {
      //       type: 'warning',
      //       showClose: false,
      //       confirmButtonText: '我知道了'
      //     })
      //   }
      // })
    },

    checkTitle (cb) {
      const { title, keywords } = this.form
      const keywordsString = keywords.map(item => item.keyword).join('')

      if (includeKeyword(title, keywordsString)) {
        cb(null)
      } else {
        cb(new Error('not include'))
      }
    },

    handleKeywordOk (keywords) {
      this.form.keywords = keywords
      this.$refs.form.validateField('keywords')
    },

    handleEditorInput () {
      this.$refs.form.validateField('content')
    },

    handleCancel () {
      this.$router.push({ name: 'ArticleList' })
    },

    handleSaveToDraft () {
      this.submit((data) => {
        this.saveArticle(data, 0, () => {
          this.$router.push({ name: 'ArticleListDraft' })
        })
      })
    },

    handlePublish () {
      this.submit((data) => {
        this.saveArticle(data, 1, () => {
          this.$router.push({ name: 'ArticleListPendingAudit' })
        })
      })
    }

  }
}
</script>

<style lang="scss">
.page-article-edit {
  .el-form-item.is-required .el-form-item__label:before {
    font-family: sans-serif;
  }

  &__form {
    margin: 30px 0;
  }

  &__submit {
    margin-top: 30px;
  }

  &__keyword-selected {
    color: $primary-color;
  }

  &__keyword-tip {
    color: #999;
  }
}
</style>
